import { Navigate, Route, Routes } from 'react-router-dom';
import { useLoginWithRedirect } from '@frontegg/react';

import { SignIn } from '~/auth';
import SettingsRoutes from '~/settings/SettingsRoutes';
import FleetManagerRoutes from '~/fleet-manager/FleetManagerRoutes';
import { ReportsPage } from '~/reports';
import { useAuthContext } from '~/shared/context/useAuthContext';
import { BreadcrumbProvider } from '~/shared/context/BreadcrumbContext';
import { ExportStateProvider } from '~/shared/context/ExportStateContext';

import Layout from './Layout';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, isAuthenticated } = useAuthContext();
  const loginWithRedirect = useLoginWithRedirect();

  if (user && isAuthenticated) {
    return children;
  }

  loginWithRedirect();

  return null;
}

function MainRoutes() {
  return (
    <ExportStateProvider>
      <BreadcrumbProvider>
        <Layout>
          <Routes>
            <Route index element={<Navigate to="fleet-manager" />} />
            <Route path="fleet-manager/*" element={<FleetManagerRoutes />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="settings/*" element={<SettingsRoutes />} />
          </Routes>
        </Layout>
      </BreadcrumbProvider>
    </ExportStateProvider>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="auth/*" element={<SignIn />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <MainRoutes />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
